import React from 'react';
import SvgTopFlapUp from '@assets/SvgTopFlapUp';
import SvgTopFlapDown from '@assets/SvgTopFlapDown';
import SvgInsideEnvelope from '@assets/SvgInsideEnvelope';
import SvgFrontFlaps from '@assets/SvgFrontFlaps';
import {
  EnvelopeContainer,
  Envelope,
  EnvelopeFront,
  EnvelopeBack,
  TopFlapOpen,
  TopFlapClose,
  VideoContainer,
  FlapsBody,
  BackFace,
  Throat,
  Root,
  Logo,
  EnveloperOverlay
} from './styles';
import { EnvelopeThemeStyle } from '@interfaces';
import RenderIf from '@components/RenderIf';
import SvgBackEnvelopeNCSU from '@assets/SvgBackEnvelopeNCSU';
import SvgBackEnvelopeSimple from '@assets/SvgBackEnvelopeSimple';

export interface IntroAnimationContainerProps {
  children: React.ReactNode;
  name?: string;
  styles?: { envelope?: EnvelopeThemeStyle };
  logoUrl?: string;
}

// The default intro animation for the application, which is no animation at all.
const DefaultIntroAnimation = ({ children }: IntroAnimationContainerProps) => (
  <>{children}</>
);

export default DefaultIntroAnimation;

export const EnvelopeIntroAnimation = ({
  children,
  name,
  styles,
  logoUrl
}: IntroAnimationContainerProps) => {
  const SVGEnvelopeBack = styles?.envelope ? SvgBackEnvelopeSimple : SvgBackEnvelopeNCSU;
  const { backgroundColor, color, playButton, backgroundImage, backgroundSize } = styles?.envelope || {};
  return (
    <Root>
      <EnvelopeContainer>
        <Envelope>
          <EnvelopeFront>
            <TopFlapOpen className="svg-parent">
              <SvgTopFlapUp color={backgroundColor} />
            </TopFlapOpen>
            <TopFlapClose className="svg-parent">
              <SvgTopFlapDown color={backgroundColor} />
            </TopFlapClose>
            <FlapsBody className="svg-parent">
              <SvgFrontFlaps color={backgroundColor} />
            </FlapsBody>
            <Throat className="svg-parent">
              <SvgInsideEnvelope color={backgroundColor} />
            </Throat>
            <VideoContainer>{children}</VideoContainer>
          </EnvelopeFront>
          <EnvelopeBack name={name} color={color}>
            <BackFace className="svg-parent">
              <RenderIf condition={!!logoUrl && !!styles?.envelope}>
                <Logo src={logoUrl} alt="" />
              </RenderIf>
              <EnveloperOverlay backgroundImage={backgroundImage} backgroundSize={backgroundSize} />
              <SVGEnvelopeBack color={backgroundColor} playIconColor={playButton?.color} playButtonBgColor={playButton?.backgroundColor} />
            </BackFace>
          </EnvelopeBack>
        </Envelope>
      </EnvelopeContainer>
    </Root>
  )
};
